var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',_vm._g({staticClass:"market-info-box__main-title"},_vm.$listeners),[_vm._v("\n    "+_vm._s(_vm.storeInfo.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }